// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kgnm","top":"styles_top__3tBij","left":"styles_left__1q4sy","description":"styles_description__cCPSW"};